// Someone without Aleta answers the web form as guest_<hex> (backend/auth/required.js
// lets these ids answer forms and nothing else). The id of the last answer sent from
// this browser is kept per form, so coming back opens that answer to change it (and
// to pay it) instead of sending another one.
const storageKey = (evId) => `aleta-form-guest-${evId}`;
const GUEST_ID = /^guest_[a-f0-9]{32}$/;

export const newGuestId = () => `guest_${Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) => byte.toString(16).padStart(2, '0')).join('')}`;

export const storedGuestId = (evId) => {
  try {
    const id = window.localStorage.getItem(storageKey(evId));
    return GUEST_ID.test(id || '') ? id : null;
  } catch {
    return null;
  }
};

export const rememberGuestId = (evId, id) => {
  try {
    window.localStorage.setItem(storageKey(evId), id);
  } catch {
    // Private windows: the answer is still sent, it just can't be opened again here
  }
};
